/* eslint-disable @typescript-eslint/no-unused-vars */
"use client";
import { Control, Controller } from "react-hook-form";
import FileUploader from "../../../components/common/FileUploader";
import InputField from "../../../components/common/InputField";
import SelectInput from "../../../components/Select";
import { useFetchVehicleAllData } from "../../../apis/vehicleApis";
import { useState } from "react";
import Input from "../../../components/Input";
import { IconCar } from "@tabler/icons-react";

type AssignModalProps = {
  register?: any;
  errors?: any;
  setValue: (name: string, value: any) => void;
  watch: (name: string) => any;
  clearErrors?: any;
  control: Control<any>;
  setMode?: (mode: string) => void;
};

const SectionHeader = ({ icon: Icon, title }: { icon: any; title: string }) => (
  <div className="flex items-center gap-2 border-b border-[#FBD037]/30 pb-2 mb-3">
    <div className="p-1.5 rounded-lg bg-[#FBD037]/20">
      <Icon size={16} className="text-[#212121]" stroke={1.5} />
    </div>
    <p className="text-[#212121]/80 uppercase text-[11px] font-bold tracking-wide">
      {title}
    </p>
  </div>
);

const ChangeVehicleModal: React.FC<AssignModalProps> = ({
  register,
  errors,
  setValue,
  clearErrors,
  watch,
  control,
}) => {
  const [assignVehicle, setAssignVehicle] = useState<any>(
    watch("vehicleId") || "",
  );
  const { data: vehicles } = useFetchVehicleAllData();

  return (
    <div className="group  rounded-2xl bg-gradient-to-b from-white/90 to-white/60 backdrop-blur-xl border border-[#D2D2D2]/70 p-4 transition-all duration-300 space-y-3">
      <div className="absolute inset-0 rounded-3xl bg-gradient-to-tr from-yellow-200/20 to-transparent pointer-events-none" />
      <SectionHeader icon={IconCar} title="Vehicle Info" />
      <div className="w-full overflow-y-auto space-y-4">
        <div className="grid grid-cols-6 gap-4">
          <SelectInput
            name="vehicleId"
            label="Select Vehicle"
            className="col-span-3"
            placeholder=""
            selectOptions={
              vehicles?.map((vehicle: any) => ({
                id: vehicle.id,
                value: vehicle.id,
                text: vehicle?.name,
              })) || []
            }
            value={watch("vehicleId")}
            setValue={(val: string) => {
              setAssignVehicle(val);
              setValue("vehicleId", val);
            }}
            clearErrors={clearErrors}
            register={register}
            error={errors?.vehicleId}
            validation={{ required: "Assign vehicle is required" }}
          />
          <Input
            title="Odometer"
            name="lastOdometer"
            className="col-span-3"
            placeholder="1002 km"
            register={register}
            error={errors.lastOdometer}
            validation={{ required: "Odometer is required" }}
          />
          <Controller
            name="inspectionPaper"
            rules={{
              required: "Inspection Paper is required",
              validate: (file) => {
                if (!file) return true;
                const MAX_SIZE = 1 * 1024 * 1024;
                if (file.size > MAX_SIZE)
                  return "File size must be 1 MB or less";
                return true;
              },
            }}
            control={control}
            render={({ field: { value, onChange }, fieldState: { error } }) => (
              <FileUploader
                name="inspectionPaper"
                classNameMain="border-none"
                extraParentClasses="col-span-6"
                title="Upload Inspection Paper"
                message="Upload only Pdf format only less then 1 Mb"
                img="/img/upload-img.png"
                classNameImgDiv="flex flex-col items-center justify-center"
                fileVal={value}
                setFileVal={onChange}
                accept="application/pdf"
                showPreview={true}
                error={error}
                required
              />
            )}
          />
        </div>
      </div>
    </div>
  );
};

export default ChangeVehicleModal;
